import React from 'react';
import { Modal, Button, theme } from 'antd';
import { useTranslation } from 'react-i18next';
import { LogoutOutlined } from '@ant-design/icons';

interface LogoutConfirmModalProps {
    open: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const clamp = (min: number, val: number, max: number) => {
    return Math.min(Math.max(val, min), max);
};

export const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({
    open,
    onCancel,
    onConfirm
}) => {
    const { t } = useTranslation();
    const { token } = theme.useToken();

    return (
        <Modal
            open={open}
            onCancel={onCancel}
            footer={null}
            closable={false}
            width={clamp(90, 420, 520)}
            style={{ backdropFilter: 'blur(4px)' }}
            bodyStyle={{ padding: '40px 32px', backgroundColor: token.colorBgContainer }}
        >
            <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 20 }}>
                <div
                    style={{
                        width: 72,
                        height: 72,
                        borderRadius: '50%',
                        background: 'var(--app-gradient)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: 28,
                        border: '2px solid var(--app-accent-soft-2)',
                        boxShadow: 'var(--app-shadow-soft)'
                    }}
                >
                    <LogoutOutlined style={{ color: token.colorWhite }} />
                </div>
                <div>
                    <h2 style={{ margin: '0 0 8px 0', fontSize: 20, fontWeight: 700, color: token.colorTextHeading, letterSpacing: '-0.3px' }}>
                        {t('logout_confirm_title', { defaultValue: 'Confirm Logout' })}
                    </h2>
                    <p style={{ margin: 0, fontSize: 14, color: token.colorTextSecondary, fontWeight: 400, lineHeight: 1.5 }}>
                        {t('logout_confirm_message', { defaultValue: 'Are you sure you want to logout? You will need to sign in again to access your account.' })}
                    </p>
                </div>
                <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
                    <Button
                        onClick={onCancel}
                        style={{ borderRadius: 10, padding: '10px 32px', fontSize: 14, fontWeight: 600, height: 40, minWidth: 120 }}
                    >
                        {t('common.cancel', { defaultValue: 'Cancel' })}
                    </Button>
                    <Button
                        type="primary"
                        danger
                        onClick={onConfirm}
                        icon={<LogoutOutlined />}
                        style={{ borderRadius: 10, padding: '10px 32px', fontSize: 14, fontWeight: 600, height: 40, minWidth: 120 }}
                    >
                        {t('common.logout', { defaultValue: 'Logout' })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
